module.exports = __webpack_public_path__ + "img/gidaija.157148f6.jpg";